export default __webpack_public_path__ + "e5a4b005d39483c8e438b00cd23921ca.png";